package twist.mena.sports.shared.dto.admin

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AdminLeagueResponse(
    val id: String,
    @SerialName("name_en") val nameEn: String,
    @SerialName("name_ar") val nameAr: String?,
    @SerialName("name_en_override") val nameEnOverride: String?,
    @SerialName("name_ar_override") val nameArOverride: String?,
    @SerialName("display_name_en") val displayNameEn: String,
    @SerialName("display_name_ar") val displayNameAr: String?,
    @SerialName("vendor_league_id") val vendorLeagueId: String,
    val type: String,
    @SerialName("synced_at_utc") val syncedAtUtc: String
)
